// @flow
import React, { type Node } from 'react';
import Helmet from 'react-helmet-async';
import { compose, pure } from 'recompose';
import { hot } from 'react-hot-loader';
import { legacyAnalytics, urlCatalog } from 'angieslist-app-platform';
import { Alert, Col, Grid, Row } from 'angieslist-react-components';
import { connect } from 'react-redux';
import { get } from 'lodash';
import './serviceAreas.scss';
import serviceAreaMapActions from '../../../app/common/service-area/serviceAreaMapActions';
import serviceAreaAnalytics from './serviceAreaViewAnalytics';
import type { ServiceAreaMapReducerStateInterface } from '../../../app/common/service-area/serviceAreaMapReducerTypes';
import type { LatLong, ServiceProviderCacheState } from '../../../app/types';
import ServiceAreaMap from '../../../app/browser/service-areas/ServiceAreaMap';

type Props = {
  params: {
    serviceProviderId: string,
  },
  serviceAreaMapStore: ServiceAreaMapReducerStateInterface,
  serviceProviderCache: ServiceProviderCacheState,
  getServiceArea: typeof serviceAreaMapActions.getServiceArea,
};

const renderError = (errorMessage = (<span>There was a problem retrieving service areas.  Please contact us at <a id="service-areas--add-service-area--store-error-link" href={urlCatalog.global.businessCenterPhone()}>{urlCatalog.global.businessCenterPhoneText()}</a> for assistance.</span>)) =>
  (
    <Alert bsStyle="danger">
      {errorMessage}
    </Alert>);

export class ServiceAreaViewComponent extends React.Component<Props> {
  componentDidMount() {
    const {
      params: { serviceProviderId }, getServiceArea,
    } = this.props;
    getServiceArea(serviceProviderId);
  }

  props: Props;

  render(): Node {
    const {
      params: { serviceProviderId }, serviceProviderCache, serviceAreaMapStore,
    } = this.props;
    const serviceProviderLocation = get(serviceProviderCache, `${serviceProviderId}.primaryAddress.location`, ({
      // default to Indianapolis
      lon: -86.1581,
      lat: 39.7684,
    }: LatLong));

    const serviceAreaResponse = get(serviceAreaMapStore, 'serviceArea.response');
    const serviceAreaResponseError = get(serviceAreaMapStore, 'serviceArea.error');
    return (
      <Choose>
        <When condition={serviceAreaResponse}>
          <div>
            <Helmet>
              <title>Manage Service Area</title>
            </Helmet>
            <ServiceAreaMap
              advertisingArea={get(serviceAreaMapStore, 'serviceArea.response.advertisingArea.postalCodes')}
              serviceArea={get(serviceAreaMapStore, 'serviceArea.response.serviceArea.postalCodes')}
              serviceProviderLocation={serviceProviderLocation}
              showEditControls
            />
          </div>
        </When>
        <When condition={serviceAreaResponseError}>
          <Grid>
            <Row>
              <Col>
                {renderError()}
              </Col>
            </Row>
          </Grid>
        </When>
      </Choose>
    );
  }
}

export default (hot(module)(compose(
  legacyAnalytics({
    ruleset: serviceAreaAnalytics,
  }),
  connect(
    state => ({
      serviceAreaMapStore: state.serviceAreaMap,
      serviceProviderCache: state.serviceProviderCache,
      experiment: state.experimentV2,
    }),
    {
      ...serviceAreaMapActions,
    },
  ),
  pure,
)(ServiceAreaViewComponent)): any);



// WEBPACK FOOTER //
// ./src/modules/store/browser/ServiceAreaView.js